import { FormattedMessage } from "react-intl";

import AlertMessage from "common/core/alert_message";
import Link from "common/core/link";
import { Substyle } from "common/core/typography";
import { PROOF_DEFEND_URL } from "constants/marketing";

import Styles from "./index.module.scss";

export function UpsellBanner() {
  return (
    <AlertMessage kind="announcement" centerText customIcon="lock">
      <div className={Styles.content}>
        <Substyle textStyle="allCapsLabelSmall">
          <FormattedMessage
            id="9815003d-b05c-409d-9a6e-92ba68812d60"
            defaultMessage="Unlock Defend"
            tagName="span"
          />
        </Substyle>
        <FormattedMessage
          id="c4f0b5a9-ac8b-4960-872b-b8c28b32f495"
          defaultMessage="See which transactions are at a higher risk for fraud"
          tagName="span"
        />
        <Link white underlined={false} href={PROOF_DEFEND_URL}>
          <FormattedMessage id="be669701-aea3-4e60-bfa9-21dc46b764fc" defaultMessage="Get Defend" />
        </Link>
      </div>
    </AlertMessage>
  );
}
